import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const BulletsContainer = styled<{ viewBullet: boolean }>(FlexContainer)`
  height: ${({ viewBullet }) => (viewBullet ? '150px' : '30px')};
  max-width: ${({ theme: { reference } }) => reference.dimension_240};
`;
